const userDataInitialState = {
    userData: {},
    isAuth:false,
    load: false
}

const userReducer = (state = userDataInitialState, action) => {
    switch(action.type) {
        case "USER_LOGIN":
            return {
                ...state,
                isAuth: true,
                load: true,
                userData: action.payload
            }
        case "USER_LOGOUT":
            return {
                ...state,
                isAuth: false,
                userData: {}
            }
        case "USER_LOAD":
            return {
                ...state,
                load: true,
            }
        default: return state;
    }
};

export default userReducer;